import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { UserRoundPen, Loader2, Wand2 } from 'lucide-react';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';

const API = `${window.__BACKEND_URL__}/api`;

// Manage Users banner: staff whose stored display name ≠ First + Middle + Last, fixed in one click.
export const NameSweepBanner = ({ token, onFixed }) => {
  const { toast } = useToast();
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [show, setShow] = useState(false);
  const load = () => axios.get(`${API}/users/name-mismatches`, auth).then((r) => setData(r.data)).catch(() => setData(null));
  useEffect(() => { if (token) load(); }, [token]);
  if (!data || data.count === 0) return null;
  const fix = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/users/name-mismatches/fix`, {}, auth);
      toast({ title: `${r.data.fixed} display name${r.data.fixed === 1 ? '' : 's'} fixed`, description: 'Staff, payroll and QuickBooks matching now use First + Middle + Last.' });
      await load(); onFixed?.();
    } catch (e) { toast({ title: 'Fix failed', description: e.response?.data?.detail || e.message, variant: 'destructive' }); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 mb-4 text-sm" data-testid="name-sweep-banner">
      <div className="flex flex-wrap items-center gap-2">
        <UserRoundPen className="w-4 h-4 text-amber-300 shrink-0" />
        <span className="text-amber-100"><b>{data.count}</b> staff member{data.count === 1 ? "'s" : "s'"} display name{data.count === 1 ? ' does' : 's do'} not match First + Middle + Last — payroll and QuickBooks matching use the display name.</span>
        <button type="button" onClick={() => setShow(!show)} className="text-xs underline text-amber-200" data-testid="name-sweep-toggle">{show ? 'Hide' : 'Show'} list</button>
        <Button size="sm" onClick={fix} disabled={busy} className="ml-auto bg-amber-500 hover:bg-amber-600 text-black" data-testid="name-sweep-fix-all">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Wand2 className="w-3.5 h-3.5 mr-1" /> Fix all {data.count}</>}</Button>
      </div>
      {show && (
        <ul className="mt-2 space-y-0.5 text-xs text-amber-100/90" data-testid="name-sweep-list">
          {data.items.map((i) => <li key={i.id} data-testid={`name-sweep-item-${i.id}`}><span className="line-through text-amber-300/70">{i.current || '—'}</span> → <b>{i.expected}</b> <span className="text-amber-200/60">({i.email})</span></li>)}
        </ul>
      )}
    </div>
  );
};
